import Dexie from "dexie";
const ENUM_DB_NAME = "imagesReportsDB";
const db = new Dexie(ENUM_DB_NAME);
db.version(1).stores({
  images: "++id,img,key"
});
export { db };
